var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 377,
    height: 339,
    viewBox: "0 0 377 339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(-807 -547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(-1578 -1132)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 135.5,
    cy: 135.5,
    r: 135.5,
    transform: "translate(2437 1679)",
    fill: "#1a1b41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(2520.092 1741.49)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 87.5,
    cy: 88,
    rx: 87.5,
    ry: 88,
    transform: "translate(-0.092 -0.49)",
    fill: "#baff29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    transform: "translate(43.908 43.51)",
    fill: "#fff",
    stroke: "#1a1b41",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5,
    cy: 44,
    rx: 43.5,
    ry: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5,
    cy: 44,
    rx: 43,
    ry: 43.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "The_Shopkeeper.",
    "data-name": "The Shopkeeper.",
    transform: "translate(807 871)",
    fill: "#040f0f",
    fontSize: 44,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "The "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#1a1b41"
  }, "Shopkeeper"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#baff29"
  }, ".")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.15c6b625e6e1b0be98706c0d133512a4.svg";
export { ForwardRef as ReactComponent };